import { Building2 } from 'lucide-react';
import { useShiftStore } from '../../store/useShiftStore';

export default function FacilitySwitcher() {
  const facilities = useShiftStore((s) => s.facilities);
  const facilityId = useShiftStore((s) => s.facilityId);
  const setFacility = useShiftStore((s) => s.setFacility);

  if (facilities.length === 0) return null;

  // One assignment is the common case; a dropdown there is just noise.
  if (facilities.length === 1) {
    return (
      <p className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-700">
        <Building2 className="h-4 w-4 text-brand-500" aria-hidden="true" />
        {facilities[0].name}
      </p>
    );
  }

  return (
    <label className="inline-flex items-center gap-2">
      <Building2 className="h-4 w-4 text-brand-500" aria-hidden="true" />
      <span className="sr-only">Facility</span>
      <select
        value={facilityId ?? ''}
        onChange={(e) => setFacility(e.target.value)}
        className="rounded-lg border border-slate-300 bg-white py-1.5 pl-2 pr-8 text-sm font-semibold text-slate-800 outline-none focus:border-brand-500"
      >
        {facilities.map((f) => (
          <option key={f.public_id} value={f.public_id}>{f.name}</option>
        ))}
      </select>
    </label>
  );
}
